import { memo, useEffect, useState } from "react";
import ControlledModal from "./ControlledPopupModal/ControlledPopupModal";
import styles from "./PopupModal.module.css";

const PopupWidgetComponent = ({
  buttonLabel,
  content,
  id,
  className = "",
  buttonClass = "",
  title = "",
  subtitle = "",
  style = {},
  overflowStyles = {},
  disabled,

  backdrop = false,
  closeButtonNeeded = true,
  dialogClassName = "modal-dialog",
  buttonTitle = "",
  onClose = () => { },
  size = "lg",
  closeButtonId = "close_contactus",
  showLogo = false,
  forceClose = false,
  variant = "",
  titleSize = "lg", // sm, md, lg, xl
}) => {
  const [show, setShow] = useState(false);
  const closeModal = () => {
    // If onClose returns false, don't close
    const shouldClose = onClose?.();
    if (shouldClose === false) return;

    setShow(false);
  };
  useEffect(() => {
    if (forceClose) {
      closeModal();
    }
  }, [forceClose]);

  return (
    <>
      <button
        title={buttonTitle}
        disabled={disabled}
        className={`${styles.modalButtonPopup} ${buttonClass}`}
        id={id}
        style={style}
        onClick={() => {
          setShow(true);
        }
          // Show the modal when button is clicked
        }
      >
        {buttonLabel}
      </button>

      <ControlledModal
        isOpen={show}
        onClose={closeModal}
        content={
          typeof content === "function" ? content({ onClose: closeModal }) : content
        }
        className={className}
        dialogClassName={dialogClassName}
        backdrop={backdrop}
        size={size}
        closeButtonNeeded={closeButtonNeeded}
        closeButtonId={closeButtonId}
        title={title}
        subtitle={subtitle}
        showLogo={showLogo}
        overflowStyles={overflowStyles}
        variant={variant}
        titleSize={titleSize}
      />
    </>
  );
};

export default memo(PopupWidgetComponent);
